import React from 'react';


const Dropdown = ({ label, options, value, onChange }) => {
  return (
    <div>
      <label>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};


const chartOptions = [
  { value: 'percentage', label: 'Søjlediagram (Ændring i forbrug pr. døgntime)' },
  { value: 'monthly', label: 'Kurvediagram (Gennemsnitlig ændring pr. last-kategori)' },
];

const ChartSelector = ({ selected, setSelected }) => (
  <Dropdown label="Diagramtype" options={chartOptions} value={selected} onChange={setSelected} />
);

export default ChartSelector;
